import React from "react";
import { useTranslation } from "react-i18next";
import info from "../../../assets/agent/agent-info.svg";

const Info = ({ clientDetails, isOpen, onToggle }) => {
  const { t } = useTranslation();

  return (
    <div className="relative">
      <button
        onClick={onToggle}
        className="flex items-center justify-center gap-2 transition-all duration-300 cursor-pointer group"
      >
        <img
          src={info}
          alt="info"
          className="w-[1.5rem] h-[1.5rem] transform transition-transform duration-300 relative"
          style={
            isOpen
              ? {
                  filter:
                    "invert(33%) sepia(93%) saturate(5696%) hue-rotate(197deg) brightness(98%) contrast(101%)",
                }
              : {}
          }
        />
        <div className="absolute right-0 top-1/2 -translate-y-14 w-[150px] px-2 py-1 bg-white text-primary text-xs rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10">
          {t("agent.tooltip.info")}
        </div>
      </button>
      {isOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30 px-4"
          onClick={onToggle}
        >
          <div
            className="bg-white shadow-2xl rounded-lg p-6 w-full max-w-3xl max-h-[85vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <h5 className="text-secondary text-lg mb-4 font-semibold">
                  {t("agent.clientInfo")}
                </h5>
                <div className="space-y-3">
                  <div>
                    <p className="font-bold text-base">{t("agent.link")}:</p>
                    <span className="text-secondary underline font-light text-base break-all cursor-pointer" onClick={() => window.open(clientDetails?.Url_Calendar, "_blank")}>
                      {clientDetails?.Url_Calendar}
                    </span>
                  </div>

                  <div>
                    <p className="font-bold text-base">{t("email")}:</p>
                    <span className="font-light text-base cursor-pointer" onClick={() => window.location.href = "mailto:andres@american-technet.com"}>
                      {clientDetails?.Contact_Email}
                    </span>
                  </div>

                  <div>
                    <p className="font-bold text-base">{t("contact")}:</p>
                    <p className="font-light text-base">
                      {clientDetails?.Contact_Person}
                    </p>
                  </div>

                  <div>
                    <p className="font-bold text-base">{t("admin.phone")}:</p>
                    <p className="font-light text-base">
                      {clientDetails?.Contact_Phone}
                    </p>
                  </div>
                </div>
              </div>
              <div>
                <h5 className="text-secondary text-lg mb-4 font-semibold">
                  {t("client.script")}
                </h5>
                <div className="space-y-3">
                  <div>
                    <p className="font-bold text-base">Reception</p>
                    <p className="text-base text-gray-800 leading-5 font-light">
                      {clientDetails?.Dialog}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Info;